<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
      :class="[
        {'hauteur-haut-brief-filtre': errors.length === 0},
        {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
          :error="errors.length > 0"
          :title="'general.problemOccurred'"
          :withEmplyFields="true"
          @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
      :class="[
        {'hauteur-brief-filtre': errors.length === 0},
        {'hauteur-brief-filtre-errors': errors.length > 0}
      ]">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOtImpression.filtre.code')">
          <qd-taginput v-model="newCritereRecherche.codes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('listeOtImpression.filtre.etat')"
          :items="constantes.LIST_ETAT_OT_TECH"
          v-model="etatsSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <input-periode
          v-model="newCritereRecherche.dates"
          :label="$t('listeOtImpression.filtre.dateSouhaite')">
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.lieuxLivraison')"
          v-model="newCritereRecherche.lieuDelivraisonIds"
          field="nomCommercial"
          :query="(search) => getAllTiers({
            query: {
              auto: search,
              societeId: societeActiveId,
              type: constantes.TIERS_TYPE_FOURNISSEUR,
              sousType: [constantes.TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON],
            }
          })">
          <template slot-scope="props">
            {{ props.option.nomCommercial }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.nomSite')"
          v-model="newCritereRecherche.clientIds"
          field="nomCommercial"
          :query="(search) => getAllTiers({
            query: {
              auto: search,
              societeId: societeActiveId,
              estLieuStockage: true,
              type: constantes.TIERS_TYPE_CLIENT,
              sousType: [constantes.TIERS_SOUS_TYPE_AUCUN],
            }
          })">
          <template slot-scope="props">
            {{ props.option.nomCommercial }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.dispositif')"
          v-model="newCritereRecherche.dispositifIds"
          field="code"
          :query="(search) => getAllDispositif({
            query: {
              auto: search,
              societeId: societeActiveId,
              actif: true,
            }
          })">
          <template slot-scope="props">
            {{ props.option.code }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.type')"
          v-model="newCritereRecherche.OtTypeIds"
          :query="(search) => pGetAll(constantes.PARAMETRES_KEYS.typeOt, {
            query:
            {
              auto: search,
              actionsInterventionsOt: [constantes.IMPRESSION_AFFICHE],
              societeId: societeActiveId,
            },
          })">
          <template slot-scope="props">
            <div>{{ props.option.libelle }}</div>
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.campagne')"
          v-model="newCritereRecherche.campagneIds"
          :query="(search) => getAllCampagnes({
            query: {
              auto: search,
              societeId: this.societeActiveId,
              actif: true,
            }
          })">
          <template slot-scope="props">
            <div>{{ props.option.libelle }}</div>
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('listeOtImpression.filtre.typeMateriel')"
          :items="materielTypes"
          field="libelle"
          v-model="materielTypeSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeOtImpression.filtre.enseigne')"
          v-model="newCritereRecherche.enseigneIds"
          field="nomCommercial"
          :query="(search) => getAllTiers({
            query: {
              auto: search,
              societeId: societeActiveId,
              type: constantes.TIERS_TYPE_CLIENT,
              typologie: [constantes.TYPOLOGIE_ENSEIGNE],
              sousType: [constantes.TIERS_SOUS_TYPE_AUCUN],
            }
          })">
          <template slot-scope="props">
            <div>{{ props.option.nomCommercial }}</div>
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input
          :label="$t('listeOtImpression.filtre.tag')"
          v-model="tagSelected"
          :query="getTags">
          <template slot-scope="props">
            {{ props.option.libelle }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input
          v-model="otTagSelected"
          :label="$t('listeOtImpression.filtre.otTag')"
          :query="getTags">
          <template slot-scope="props">
            {{ props.option.libelle }}
          </template>
        </query-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche
  from '@/services/logistique/ordreTravail/impression/genererCritereRecherche';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { SET_CRITERE } from '@/store/modules/logistique/ordreTravailImpression-mutation-type';
import { getAll as getAllTiers } from '@/api/tiers';
import { getAll as getAllDispositif } from '@/api/gabed/dispositif';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { pGetAll } from '@/api/parametre/index';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
  TIERS_TYPE_CLIENT,
  TIERS_SOUS_TYPE_AUCUN,
  TYPOLOGIE_ENSEIGNE,
} from '@/configuration/tiers/tiersConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import inputPeriode from '@/components/general/inputPeriode';
import { getAll as getAllTags } from '@/api/tag/index';
import { DEMANDE_IMPRESSION } from '@/configuration/parametrage/tagConf';

const Parametres = createNamespacedHelpers('parametres');
const OtImpression = createNamespacedHelpers('ordreTravailImpression');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      newCritereRecherche: null,
      constantes: {
        LIST_ETAT_OT_TECH,
        IMPRESSION_AFFICHE,
        TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
        TIERS_TYPE_FOURNISSEUR,
        TIERS_TYPE_CLIENT,
        TIERS_SOUS_TYPE_AUCUN,
        TYPOLOGIE_ENSEIGNE,
        PARAMETRES_KEYS,
        DEMANDE_IMPRESSION,
      },
      etatsSelected: [],
      errors: [],
      getAllTiers,
      getAllDispositif,
      getAllCampagnes,
      pGetAll,
      materielTypeSelected: [],
      tagSelected: [],
      otTagSelected: [],
    };
  },
  components: {
    libelleTagInput,
    errorMsgComponent,
    queryTagInput,
    inputPeriode,
  },
  computed: {
    ...OtImpression.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType).filter(m => m.actif);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...OtImpression.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    appliquerCritere() {
      this.errors = [];
      if (this.newCritereRecherche.dates
        && moment(this.newCritereRecherche.dates.dateDebut)
          .isAfter(this.newCritereRecherche.dates.dateFin)) {
        this.errors.push({ message: 'listeOrdreTravailTech.filtre.error.dates' });
      }
      if (this.errors.length) return;
      this.newCritereRecherche.materielTypeIds = this.materielTypeSelected.map(el => {
        return el.id;
      });
      this.newCritereRecherche.etats = this.etatsSelected.map(el => { return el.code; });
      this.newCritereRecherche.tagIds = this.tagSelected.map((tag) => tag.id);
      this.newCritereRecherche.otTagIds = this.otTagSelected.map((tag) => tag.id);
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.materielTypeSelected = [];
      this.etatsSelected = [];
      this.tagSelected = [];
      this.otTagSelected = [];
      this.newCritereRecherche = genererCritereRecherche();
      this.getEtatTag();
    },
    getEtatTag() {
      if (this.newCritereRecherche.etats.length > 0) {
        this.etatsSelected = this.constantes.LIST_ETAT_OT_TECH.filter((e) => {
          return this.newCritereRecherche.etats.includes(e.code);
        });
      }
    },
    getTags(search) {
      return getAllTags({
        query:
          {
            auto: search,
            actif: true,
            moduleTag: this.constantes.DEMANDE_IMPRESSION,
          },
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametres([
          PARAMETRES_KEYS.materielType,
        ]);
        this.getEtatTag();

        this.materielTypeBase = this.materielType;
        if (this.newCritereRecherche.typesMateriels) {
          this.materielTypeSelected = this.materielTypes.filter((m) => {
            return this.newCritereRecherche.typesMateriels.includes(m.id);
          });
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    await this.initializeFiltre();
  },
};

</script>
